import { render } from "./ReadingQuestionInput.vue?vue&type=template&id=b0377c5c&scoped=true&lang=true"
import script from "./ReadingQuestionInput.vue?vue&type=script&lang=js"
export * from "./ReadingQuestionInput.vue?vue&type=script&lang=js"

import "./ReadingQuestionInput.vue?vue&type=style&index=0&id=b0377c5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0377c5c"]])

export default __exports__